import { FC, useEffect, useState } from 'react'
import { Tabs } from 'antd'
import {
    Pagination,
    CertificateCard,
    Card,
    ContractCard,
    LoadingContainer,
    ThirdPartyToolsCard,
} from '../../../ui'
import { Box } from '../../../ui/Box/Box'
import { ControlsBlock } from './components'
import { getCertificates, getGreenContracts, getOther } from '../../config'
import {useFilters, usePrevious} from '../../../hooks'
import useRequest from '../../../hooks/useRequest'
import { monthPicker, statusIdPicker } from '../../../helpers'
import { useAppSelector } from '../../../../store/hooks'
import { selectDictionariesMaps } from '../../../../store/dictionaries'
import { FolderCross } from '../../../../assets/icons'
import { EUserRole } from '../../../../constants/profile'
import { IContract, IOther } from './types'
import moment from 'moment'
import { useLocation, useNavigate } from 'react-router-dom'
import style from './style.m.less'

// TODO REFACT MANY PROPS FOR CHILDRENS
const { TabPane } = Tabs

const shortCertificatesList = [
    { label: 'Активные', id: '5d0bbe80-2e0e-4698-8daf-7df24ce6ba83' },
    { label: 'Погашенные', id: 'fe794a9b-3213-40bc-82b4-aac2919f177e' },
    { label: 'Заблокированные', id: 'gq894a9b-3213-40bc-82b4-aac2919f177e' },
    { label: 'Истек срок действия', id: '7q1bbe80-2e0e-4698-8daf-7df24ce6ba83' },
]

const certificatesList = [
    ...shortCertificatesList,
    { label: 'Удаленные', id: 'bd3bbe80-2e0e-4698-8daf-7df24ce6ba83' },
    { label: 'На ЭТП', id: '5g194a9b-3213-40bc-82b4-aac2919f177e' },
]

const contractsList = [
    { label: 'Активные', id: '5b7f77bf-a3ec-4441-9b13-e46eabc3c027' },
    { label: 'Заблокированные', id: '87f3386e-0358-4f90-bc8b-b655ce181bb8' },
    { label: 'Неоплаченные', id: '4e794a9b-3213-40bc-82b4-aac2919f177e22' },
    { label: 'Потребители не указаны', id: '5de09b87-5cd8-4c01-b4d8-3e866ee5b067' },
]

const otherList = [
    { label: 'Активные', id: '5d0bbe80-2e0e-4698-8daf-7df24ce6ba83' },
    { label: 'Погашенные', id: 'fe794a9b-3213-40bc-82b4-aac2919f177e' },
]

const tabsList = [
    { label: 'Сертификаты происхождения', key: 0, content: <></> },
    { label: 'Зеленые договоры', key: 1, content: <></> },
    { label: 'Сторонние инструменты', key: 2, content: <></> },
]

interface IRegisteredLayout {
    isUserType?: boolean
    userRole: number
}

const PAGE_SIZE = 10

const DEFAULT_PAG = {
    page: 1,
    pageSize: PAGE_SIZE,
}

type PaginationType = {
    page?: number
    pageSize?: number
    filters?: any
}

const RegisteredLayout: FC<IRegisteredLayout> = ({ isUserType, userRole }) => {
    const location = useLocation();
    const navigate = useNavigate()
    const [isAdminType, setIsAdminType] = useState<boolean>(false)

    // const [currentTool, setCurrentTool] = useState(tabsList[0].label)
    const [currentTool, setCurrentTool] = useState(() => {
        if (tabsList[Number(localStorage.getItem('green_tools_current_tool_key'))]) {
            return tabsList[Number(localStorage.getItem('green_tools_current_tool_key'))].label
        } else {
            localStorage.setItem('green_tools_current_tool_key', '0')
            return tabsList[0].label
        }
    })

    const optionsList =
        currentTool === 'Сертификаты происхождения' && isAdminType
            ? certificatesList
            : currentTool === 'Сертификаты происхождения'
            ? shortCertificatesList
            : currentTool === 'Зеленые договоры'
            ? contractsList
            : otherList
    const [option, setOption] = useState(() => {
        if (optionsList[Number(localStorage.getItem('green_tools_option_key'))]) {
            return optionsList[Number(localStorage.getItem('green_tools_option_key'))].label
        } else {
            localStorage.setItem('green_tools_option_key', '0')
            return optionsList[0].label
        }
    })
    const userData = useAppSelector((state) => state.user.data)
    const userId = userData.uid

    const { renewableEnergyTypesMap } = useAppSelector(selectDictionariesMaps) ?? {}

    const getEnergyType = (item: number) => renewableEnergyTypesMap?.get(item)

    const {
        fetch: fetchCertificates,
        result: certificates,
        isLoading: isLoadingCertificates,
    } = useRequest(getCertificates)
    const {
        fetch: fetchContracts,
        result: contracts,
        isLoading: isLoadingContracts,
    } = useRequest(getGreenContracts)
    const { fetch: fetchOther, result: others, isLoading: isLoadingOther } = useRequest(getOther)

    const [pagination, setPagination] = useState<PaginationType>(() => {
        if (localStorage.getItem('green_tools_pagination')) {
            return JSON.parse(localStorage.getItem('green_tools_pagination'))
        } else {
            localStorage.setItem('green_tools_pagination', JSON.stringify(DEFAULT_PAG))
            return DEFAULT_PAG
        }
    })
    const [filters, setFilters] = useState<any>(() => {
        if (localStorage.getItem('green_tools_filters')) {
            return JSON.parse(localStorage.getItem('green_tools_filters'))
        } else {
            localStorage.setItem('green_tools_filters', JSON.stringify({}))
            return {}
        }
    })
    // const [filters, setFilters] = useFilters()

    const isGreenContracts = currentTool === 'Зеленые договоры'
    const isCertificate = currentTool === 'Сертификаты происхождения'

    const result = isGreenContracts ? contracts : isCertificate ? certificates : others
    const isLoading = isLoadingCertificates || isLoadingContracts || isLoadingOther

    const getData = ({ page = 1, pageSize = 10, filters }: PaginationType) => {
        ;(isGreenContracts ? fetchContracts : isCertificate ? fetchCertificates : fetchOther)({
            body: {
                limit: pageSize,
                offset: (page - 1) * pageSize,
                filters,
            },
            errorCodeMessage: true,
        })
    }

    const prevTool = usePrevious(currentTool)
    useEffect(() => {
        if (location.state && location.state.fromMenu) {
            setCurrentTool(tabsList[0].label)
            localStorage.setItem('green_tools_current_tool_key', '0')
            setOption(optionsList[0].label)
            localStorage.setItem('green_tools_option_key', '0')
            setPagination(DEFAULT_PAG)
            localStorage.setItem('green_tools_pagination', JSON.stringify(DEFAULT_PAG))
            setFilters({ status_id: 1 })
            localStorage.setItem('green_tools_filters', JSON.stringify({ status_id: 1 }))

            navigate(location.pathname, {state: {fromMenu: false}})
        } else {
            if (optionsList[Number(localStorage.getItem('green_tools_option_key'))]) {
                setOption(optionsList[Number(localStorage.getItem('green_tools_option_key'))].label)
            } else {
                localStorage.setItem('green_tools_option_key', '0')
                setOption(optionsList[0].label)
            }

            if (Object.keys(filters).length) {
                if (prevTool !== currentTool) {
                    setFilters({status_id: 1})
                    getData({filters: {status_id: 1}})
                } else {
                    getData({page: pagination.page, pageSize: pagination.pageSize, filters: filters})
                }
            }
        }
    }, [currentTool])

    const updateFilters = (data: string | number | boolean, key: string, obj?: any, saveStatePagination?: boolean) => {
        let updatedFilter
        if (location.state && location.state.fromMenu) {
            updatedFilter = obj ? {...obj} : {[key]: data}
        } else {
            if (key === 'account_number') {
                const filterCopy = {...filters}
                delete filterCopy.generator_id
                updatedFilter = {
                    ...filterCopy,
                    ...(obj ? {...obj} : {[key]: data}),
                }
            } else {
                updatedFilter = {
                    ...filters,
                    ...(obj ? {...obj} : {[key]: data}),
                }
            }
        }

        setFilters(updatedFilter)
        localStorage.setItem('green_tools_filters', JSON.stringify(updatedFilter))

        if (localStorage.getItem('green_tools_pagination') && saveStatePagination && !(location.state && location.state.fromMenu)) {
            let green_tools_pagination = JSON.parse(localStorage.getItem('green_tools_pagination'))
            setPagination(green_tools_pagination)
            getData({ page: green_tools_pagination.page, pageSize: green_tools_pagination.pageSize, filters: updatedFilter })
        } else {
            setPagination({ page: 1, pageSize: pagination.pageSize })
            getData({ page: 1, pageSize: pagination.pageSize, filters: updatedFilter })
            localStorage.setItem('green_tools_pagination', JSON.stringify({ page: 1, pageSize: pagination.pageSize }))
        }

        // setPagination({ page: 1, pageSize: pagination.pageSize })
        // getData({ page: 1, pageSize: pagination.pageSize, filters: updatedFilter })
    }

    const onChange = (value: string) => {
        setOption(value)
        optionsList.map((item, index) => {
            if (item.label == value) {
                localStorage.setItem('green_tools_option_key', String(index))
            }
        })
        setPagination(DEFAULT_PAG)
        localStorage.setItem('green_tools_pagination', JSON.stringify(DEFAULT_PAG))
        updateFilters(statusIdPicker(value), 'status_id')
    }

    useEffect(() => {
        const isIncluded = [
            EUserRole.Operator,
            EUserRole.Administrator,
            EUserRole.SuperAdmin,
        ].includes(userRole)
        if (isIncluded !== isAdminType) {
            setIsAdminType(isIncluded)
        }
    }, [userRole])

    return (
        <div className={style.mainWrapper}>
            <Tabs
                defaultActiveKey={!(location.state && location.state.fromMenu) && localStorage.getItem('green_tools_current_tool_key')
                    ? localStorage.getItem('green_tools_current_tool_key')
                    : "0"
                }
                onChange={(activeKey) => {
                    const activeNumber = Number(activeKey)
                    setCurrentTool(tabsList[activeNumber].label)
                    localStorage.setItem('green_tools_current_tool_key', activeKey)
                    setOption(optionsList[0].label)
                    localStorage.setItem('green_tools_option_key', '0')
                    setPagination(DEFAULT_PAG)
                    localStorage.setItem('green_tools_pagination', JSON.stringify(DEFAULT_PAG))
                    setFilters({ status_id: 1 })
                    localStorage.setItem('green_tools_filters', JSON.stringify({ status_id: 1 }))
                }}
                className={style.tabs}
            >
                {tabsList.map((item) => {
                    const { label, key, content } = item

                    return (
                        <TabPane tab={label} key={key}>
                            {content}
                        </TabPane>
                    )
                })}
            </Tabs>
            <ControlsBlock
                options={optionsList}
                currentOption={option}
                toolType={currentTool}
                isUserType={isUserType}
                onChange={onChange}
                total={result?.total}
                isDisabled={!result?.certificates?.length}
                onChangeFilters={updateFilters}
                isAdminType={isAdminType}
                filters={filters}
            />
            <LoadingContainer isLoading={isLoading}>
                <div className={style.cardsWrapper}>
                    {result?.certificates?.map((item, index) => {
                        const {
                            certificate_id,
                            certificate_number,
                            renewable_energy_type_id,
                            status_id,
                            volume,
                            generator_name,
                            ts_created,
                            ts_expired,
                            ts_deleted,
                            month,
                            year,
                            is_owner,
                            is_etp,
                            is_deposit,
                            generator_id,
                        } = item
                        const productionPeriod = `${monthPicker(month)} ${year}`

                        return (
                            <div key={certificate_number}>
                                <CertificateCard
                                    isRegistered
                                    isUserType={isUserType}
                                    toolType={currentTool}
                                    certificateNumber={certificate_number}
                                    option={status_id}
                                    energyType={getEnergyType(renewable_energy_type_id)}
                                    capacity={volume}
                                    productionPeriod={productionPeriod}
                                    generatorName={generator_name}
                                    generator_id={generator_id}
                                    certificateId={certificate_id}
                                    isOwner={is_owner}
                                    isEtp={is_etp}
                                    isDeposit={is_deposit}
                                    createdTs={moment(ts_created).format('DD.MM.YYYY')}
                                    expiredTs={moment(ts_expired).format('DD.MM.YYYY')}
                                    deletedTs={
                                        ts_deleted ? moment(ts_deleted).format('DD.MM.YYYY') : '-'
                                    }
                                    {...item}
                                />
                            </div>
                        )
                    })}
                    {result?.contracts?.map((contract: IContract) => {
                        const isOwner =
                            userId === contract.buyer_uid || userId === contract.seller_uid
                        return (
                            <ContractCard
                                isRegistered
                                isOwner={isOwner}
                                contract={contract}
                                key={contract.contract_id}
                            />
                        )
                    })}
                    {result?.ext_instruments?.map((tool: IOther) => {
                        const isOwner = userId === tool.owner
                        return (
                            <ThirdPartyToolsCard
                                isRegistered
                                isOwner={isOwner}
                                tool={tool}
                                key={tool.id}
                            />
                        )
                    })}
                </div>
                {!result?.total && (
                    <Card className={style.card}>
                        <Box>
                            <FolderCross />
                            <div className={style.textAlert}>Ничего не найдено</div>
                        </Box>
                    </Card>
                )}
            </LoadingContainer>

            {result?.total > 10 && (
                <Pagination
                    paginationChange={(page, pageSize) => {
                        getData({ page, pageSize, filters })
                        setPagination({ page, pageSize })
                        localStorage.setItem('green_tools_pagination', JSON.stringify({ page: page, pageSize: pageSize }))
                    }}
                    total={result?.total}
                    current={pagination.page}
                    pageSize={pagination.pageSize}
                    showSizeChanger={true}
                    customStyle={{ width: '100%' }}
                />
            )}
        </div>
    )
}

export default RegisteredLayout
